import { formatString } from 'xen/helpers/format';
/** Returns address object formatted like '123 Main St. Somewhere, NY 12345' */
export const formatAddress = (address) => {
    const { squeezeValues: squeeze } = formatString;
    const { city, line1, postalCode, state } = address;
    if (!line1 && !city && !state && !postalCode) {
        return '';
    }
    if (!line1 && !city) {
        return squeeze([state, postalCode]);
    }
    if (!state && !postalCode) {
        return squeeze([line1, city]);
    }
    return squeeze([line1, `${city},`, state, postalCode]);
};
